import { store } from "global";
import { AudioControllerType } from "models/app/player";

const isControllerChromecast = (controller: AudioControllerType) => controller === AudioControllerType.Chromecast;
export const isControllerChromecastFromState = () => isControllerChromecast(store.getState().player.controller);

const isControllerLocal = (controller: AudioControllerType) => controller === AudioControllerType.Local;
export const isControllerLocalFromState = () => isControllerLocal(store.getState().player.controller);
